import { useEffect, useState } from 'react';
import { App as CapacitorApp } from '@capacitor/app';
import { isNative } from '@/native';

/**
 * 手机上装的这一版给人看的版本号（0.0.x，CR-068），「我的」页显示。
 *
 * 客户原话「版本号为了方便管理」—— 工人报问题时能说出「我是 0.0.3」，不用插线 adb 才知道装的是哪版。
 * 网页端没有「版本」这回事（天天都是最新的），返回 null 就不显示。
 */
export function useAppVersion(): string | null {
  const [version, setVersion] = useState<string | null>(null);

  useEffect(() => {
    if (!isNative) return;
    let alive = true;
    CapacitorApp.getInfo()
      .then((info) => {
        if (alive) setVersion(info.version || null);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);

  return version;
}
